import { useEffect } from "react";
import axios from "axios";
import { useProjectConfigContext } from "../contexts/ProjectConfigContext";
import { useNavigate } from "react-router-dom";
import useTags from "./useTags";
import { TypeErrorCodeToMessageMap } from "../interface/API/apiError.interface";
import defualtLolaTechHttpErrorsLang from "../data/lang/lola-tech-http-errors.lang";
import { convertStrToErrorCode } from "../helpers/handle-errors";
import { REACT_APP_BASE_PERMIT_API_URL, REACT_APP_BASE_PERMIT_API_URL_NEW_API } from "../axios/axios-api";
import { ApiResponseError } from "../errors/api-response-error";
import { useGetUseNewApiApp } from "../stores/app.store";

const baseNewApi = REACT_APP_BASE_PERMIT_API_URL_NEW_API + '/portal';
const baseApi = REACT_APP_BASE_PERMIT_API_URL + '/portal';

const axiosLolatechPortalPrivate = axios.create({ baseURL: baseApi });
const axiosLolatechPrivate = axios.create({ baseURL: REACT_APP_BASE_PERMIT_API_URL });

const useAxiosPrivateToken = () => {

    const useNewApi = useGetUseNewApiApp();
    const { authState, projectConfigState } = useProjectConfigContext();
    const generateTag = useTags();
    const navigate = useNavigate();

    const basePortal = useNewApi ? baseNewApi : baseApi;
    const base = useNewApi ? REACT_APP_BASE_PERMIT_API_URL_NEW_API : REACT_APP_BASE_PERMIT_API_URL;

    const projectId = projectConfigState.projectId;

    useEffect(() => {

        axiosLolatechPortalPrivate.defaults.baseURL = basePortal;
        axiosLolatechPrivate.defaults.baseURL = base;

        const requestInterceptPrivate = axiosLolatechPortalPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${authState.token}`;
                }

                return config;
            }, (error) => Promise.reject(error)
        );

        const responseInterceptPrivate = axiosLolatechPortalPrivate.interceptors.response.use(
            response => response,
            async (error) => {

                const prevRequest = error?.config;

                if (error?.response?.status === 401) {
                    navigate(`/home/${projectId}`);
                }

                return Promise.reject(error);
            }
        );

        const requestIntercept = axiosLolatechPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${authState.token}`;
                }

                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosLolatechPrivate.interceptors.response.use(
            response => response,
            async (error) => {

                const prevRequest = error?.config;

                if (error?.response?.status === 401) {
                    navigate(`/home/${projectId}`);
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosLolatechPortalPrivate.interceptors.request.eject(requestInterceptPrivate);
            axiosLolatechPortalPrivate.interceptors.response.eject(responseInterceptPrivate);
            axiosLolatechPrivate.interceptors.request.eject(requestIntercept);
            axiosLolatechPrivate.interceptors.response.eject(responseIntercept);
        }

    }, [authState, useNewApi]);

    function handleError(error: any, messageDescrption?: TypeErrorCodeToMessageMap) {

        console.error(error);

        let message = '';

        if (error instanceof ApiResponseError) {

            message = generateTag(defualtLolaTechHttpErrorsLang, 'INVALID_RESPONSE_API');
            return message;
        }

        if (error?.response) {

            const data = error.response.data;

            console.log('Error response data:', data);
            message = translateErrorCode(error, messageDescrption);
        } else if (error?.request) {

            console.log('Error request:', error.request);
            message = generateTag(defualtLolaTechHttpErrorsLang, 'GENERAL_ERROR_FRONT_END');
        } else {

            // Something happened in setting up the request that triggered an Error
            console.log('Error message:', error.message);
            message = generateTag(defualtLolaTechHttpErrorsLang, 'GENERAL_ERROR_FRONT_END');
        }

        console.log('Error message:', message);
        return message;
    }

    function translateErrorCode(error: any, messageDescrption?: TypeErrorCodeToMessageMap): string {

        let message: string = generateTag(defualtLolaTechHttpErrorsLang, 'GENERAL_ERROR');
        const data = error.response.data;

        const errorCode = convertStrToErrorCode(data.errorName);

        if (messageDescrption && messageDescrption[errorCode]) {
            return generateTag(messageDescrption, errorCode);
        }

        if (defualtLolaTechHttpErrorsLang[errorCode]) {
            message = generateTag(defualtLolaTechHttpErrorsLang, errorCode);
        }

        console.log(error.response.data);
        return message;
    }

    return {
        axiosLolatechPrivate,
        axiosLolatechPortalPrivate,
        handleError
    };

}

export default useAxiosPrivateToken;